export const disableActionsByDefault = (columnId: string) => {
  return (
    columnId === 'produto-id' ||
    columnId === 'centro-id' ||
    columnId === 'compra-desejada'
  )
}
